import { useState, useEffect } from "react";
import axios from "axios";

// Default brand metrics — mirror backend routes/brand.py DEFAULTS so render is
// instant (no CLS); the fetch below overrides them from the single source of truth.
export const BRAND_DEFAULTS = {
  follower_social: "oltre 80.000 follower sui social",
  follower_count: "80.000",
  iscritti_newsletter: "quasi 7.000 iscritti alla newsletter",
  recensioni_google_voto: "5,0",
  recensioni_google: "oltre 450 recensioni",
  consulenze_svolte: "oltre 1.000 consulenze",
  org_name: "Vita da Host",
  sede: "Genova, Liguria, Italia",
  fondatore: "Sergio Battelli",
  anno_fondazione: "2023",
  piva: "02903680995",
  email: "vitadahost@gmail.com",
  telefono: "+39 333 368 8328",
  prova_hostland_giorni: 30,
};

let _cache = null;

export default function useBrand() {
  const [brand, setBrand] = useState(_cache || BRAND_DEFAULTS);
  useEffect(() => {
    if (_cache) return;
    let alive = true;
    axios
      .get(`${window.__BACKEND__}/api/public/brand`)
      .then((r) => {
        _cache = { ...BRAND_DEFAULTS, ...(r.data || {}) };
        if (alive) setBrand(_cache);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return brand;
}
